const TIMEOUT = 10000

const audio = {
    "Laurens Kepel": {
        appointment: new Audio(require("motivate-dashboarding-components/sounds/motivate/test.mp3"))
    },
    "Paul Snellen": {
        appointment: new Audio(require("motivate-dashboarding-components/sounds/motivate/test.mp3"))
    }
}

const player = function (user, action, timeout) {
    var playAudio = audio[user][action]
    playAudio.play().then(stopAudio(playAudio, timeout))
}


export default player;


function stopAudio(audio, timeout) {
    setTimeout(function () {
        audio.pause();
        audio.currentTime = 0;
    }, timeout ? timeout : TIMEOUT)
}
